var _path, _path2, _g, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconScan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 91,
    viewBox: "0 0 110 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3436 87.4279C78.4328 87.4279 97.1502 67.8565 97.1502 43.714C97.1502 19.5714 78.4328 0 55.3436 0C32.2545 0 13.5371 19.5714 13.5371 43.714C13.5371 67.8565 32.2545 87.4279 55.3436 87.4279Z",
    fill: "#E1E9EE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4460_7214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 85,
    height: 88
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3436 87.4279C78.4328 87.4279 97.1502 67.8565 97.1502 43.714C97.1502 19.5714 78.4328 0 55.3436 0C32.2545 0 13.5371 19.5714 13.5371 43.714C13.5371 67.8565 32.2545 87.4279 55.3436 87.4279Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4460_7214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3651 90.9993L88.8468 77.6825C88.8468 73.988 85.5591 71.6398 82.1016 70.2553C76.4214 67.9759 63.394 62.8281 63.394 62.8281C63.394 62.8281 62.0589 70.9361 54.6499 70.9361C47.897 70.9361 46.091 62.8281 46.091 62.8281C46.091 62.8281 32.261 67.4787 27.3912 70.2553C24.1652 72.0987 20.2832 74.5846 20.2832 76.3133L22.1895 90.9993H87.3651Z",
    fill: "#5BB64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3948 62.8439C63.3948 62.8439 62.4301 71.0819 54.6044 71.0819C47.3884 71.0819 46.0918 62.8439 46.0918 62.8439V54.4453H63.3948V62.8439Z",
    fill: "#E78779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1806 44.7684C73.1806 51.2547 64.4442 60.1275 54.7431 60.1275C45.042 60.1275 36.3288 52.448 36.3288 44.7684L35.5879 30.526C35.5879 20.0392 44.1622 11.5488 54.7354 11.5488C65.3163 11.5488 73.8906 20.0392 73.8906 30.526L73.1729 44.7684H73.1806Z",
    fill: "#F69583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1597 39.2163C76.0825 41.4268 74.6856 43.1708 73.034 43.1096C71.3747 43.0484 70.109 41.2203 70.1785 39.0098C70.2557 36.8069 71.6526 35.0629 73.2964 35.1164C74.948 35.17 76.2292 37.0057 76.152 39.2086L76.1597 39.2163Z",
    fill: "#F69583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2769 38.8398C39.3463 41.0504 38.0652 42.8785 36.4136 42.9321C34.762 42.978 33.3651 41.234 33.2957 39.0311C33.2262 36.8282 34.4996 35.0001 36.1512 34.9465C37.8028 34.893 39.1997 36.6369 39.2769 38.8398Z",
    fill: "#F69583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0689 38.1981C37.0689 38.1981 40.758 34.7178 40.6191 28.6292C40.5264 24.7129 45.9056 23.3131 54.0941 23.3131C62.2825 23.3131 70.3243 25.1795 69.7146 29.0422C68.7113 35.322 72.655 38.1981 72.655 38.1981H73.7432L74.7851 33.9529C74.7851 33.9529 79.8247 22.1887 64.1656 10.7C63.2009 9.99625 60.3994 8.0993 61.5725 4.91733C61.5725 4.91733 56.911 5.65163 55.0665 9.00188C55.0665 9.00188 54.9199 5.55984 58.5472 1.68945C58.5472 1.68945 42.9884 2.45435 35.51 20.6207C32.23 28.5833 34.8848 35.7351 36.0348 38.1981H37.0766H37.0689Z",
    fill: "#4C3B25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.267 46.8801C55.1744 46.8801 55.074 46.8801 54.9891 46.8724C54.8271 46.8571 54.6959 46.7118 54.719 46.5588C54.7345 46.3982 54.8579 46.2682 55.0432 46.2911C55.6374 46.3523 56.0851 46.1764 56.1314 46.0463C56.1545 45.9928 56.1005 45.7863 55.6066 45.4574C54.1248 44.463 53.955 40.9904 53.9473 40.845C53.9473 40.6844 54.0707 40.5467 54.2405 40.5391C54.4026 40.5391 54.5338 40.6538 54.5415 40.8144C54.5801 41.74 54.912 44.2794 55.9384 44.9755C56.5944 45.4038 56.8414 45.8322 56.6947 46.2376C56.525 46.6965 55.8921 46.8801 55.267 46.8801Z",
    fill: "#071938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4427 38.5506C45.0028 38.5506 44.6015 38.7265 44.3159 39.0402C44.0767 39.3232 43.9609 39.6827 43.9609 40.0651C43.9609 40.8224 44.478 41.6026 45.4427 41.6026C45.9058 41.6026 46.3071 41.419 46.5849 41.0977C46.8242 40.8224 46.9554 40.4629 46.9554 40.0651C46.9554 39.3155 46.446 38.543 45.4427 38.543V38.5506Z",
    fill: "#071938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9951 38.5506C64.435 38.5506 64.8363 38.7265 65.1219 39.0402C65.3534 39.3232 65.4769 39.6827 65.4769 40.0651C65.4769 40.8224 64.9598 41.6026 63.9951 41.6026C63.532 41.6026 63.1307 41.419 62.8529 41.0977C62.6136 40.8224 62.4824 40.4629 62.4824 40.0651C62.4824 39.3155 62.9995 38.543 63.9951 38.543V38.5506Z",
    fill: "#071938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5297 34.7022C67.5297 34.7022 65.8704 32.6599 62.1582 33.8991",
    stroke: "#071938",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3164 34.7022C42.3164 34.7022 43.9757 32.6599 47.6802 33.8991",
    stroke: "#071938",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0723 51.1934C50.1572 53.7558 52.4802 55.8133 55.3434 55.8133C58.2067 55.8133 60.5297 53.7558 60.6069 51.1934H50.0723Z",
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 41.5,
    x2: 109.5,
    y2: 41.5,
    stroke: "#4A4A68",
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScan);
export default __webpack_public_path__ + "static/media/icon-scan.ac7d77348dc100b06ea971e955e56388.svg";
export { ForwardRef as ReactComponent };